import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import QuestionMark from "../../../assets/Icon/QuestionMark";
import CustomInput from "../../UI/CustomInput";
import Popover from "@mui/material/Popover";
import CustomButton from "../../UI/CustomButton/inedx";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { toast } from "react-toastify";
import cs from "classnames";
import TooltipButton from "../../UI/TooltipButton";

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          margin: 0,
          padding: 0,
        },
      },
    },
  },
});

const StepTwo = ({
  data,
  setData,
  calculatorType,
  handleBlur,
  dataError,
  setDataError,
  handleEnter,
}) => {
  const isProfit = calculatorType === "calc-3";
  const [anchorEl, setAnchorEl] = useState<any>();
  const [isZipSet, setIsZipSet] = useState(false);
  const [zip, setZip] = useState("");

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleZipSet = () => {
    if (!zip)
      return toast("Enter your zip code.", {
        type: "error",
        toastId: "your_zip_code",
      });
    setIsZipSet(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = ({ target: { value, name } }) => {
    if (!value) {
      ["calc-1", "calc-3"].includes(calculatorType)
        ? setDataError({
            ...dataError,
            valueOfEachHourError: true,
          })
        : setDataError({
            ...dataError,
            profitError: true,
          });
    } else {
      ["calc-1", "calc-3"].includes(calculatorType)
        ? setDataError({
            ...dataError,
            valueOfEachHourError: false,
          })
        : setDataError({
            ...dataError,
            profitError: false,
          });
    }
    setData({ ...data, [name]: value });
  };
  return (
    <div>
      <p className="mt-5 mb-0">
        {isProfit
          ? "What is the profit per product? "
          : " How much do you value your labor at per hour? (This is optional)"}

        <TooltipButton
          title={
            isProfit
              ? "Ex: The profit for your homemade candle is $20."
              : "Ex: You value your time at $12 an hour."
          }
          icon={<QuestionMark />}
        />
      </p>
      <div className="d-flex align-items-center">
        <span className="font-currency mr-2">$</span>
        <CustomInput
          formControlClass="time-input"
          placeholder="00.00"
          type="number"
          name={isProfit ? "profit" : "valueOfEachHour"}
          value={isProfit ? data.profit : data.valueOfEachHour}
          onBlur={handleBlur}
          autoFocus
          min="0"
          defaultValue={0}
          onKeyPress={handleEnter}
          onChange={handleChange}
          className={cs(
            {
              ["error-input"]: dataError.profitError,
            },
            {
              ["error-input"]: dataError.valueOfEachHourError,
            }
          )}
        />
        {calculatorType !== "calc-3" && <span className="ml-2">/ hour</span>}
      </div>
      {!isProfit && (
        <ThemeProvider theme={theme}>
          {/*TODO: this is feature “I don’t know how to calculate this”  */}
          {/*<div*/}
          {/*  className="mt-3 ml-4 text-decoration-underline pointer-cursor"*/}
          {/*  onClick={handleOpen}*/}
          {/*>*/}
          {/*  I don't know how to calculate this*/}
          {/*</div>*/}
          <Popover
            id={Boolean(anchorEl) ? "simple-popover" : undefined}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <div className="zip-tooltip-wrapper p-3">
              <h6 className="header-contents">What is your zip code?</h6>
              <div className="d-flex align-items-center mb-4 ">
                <CustomInput
                  className={"w-5 zip-input"}
                  placeholder="888888"
                  type="number"
                  min="0"
                  value={zip}
                  onChange={({ target: { value } }) => setZip(value)}
                />
                <CustomButton className="zip-btn ml-2" onClick={handleZipSet}>
                  Enter
                </CustomButton>
              </div>

              {isZipSet && (
                <div className="d-flex align-items-center justify-content-between zip-description">
                  <div className="value-text">
                    Use this value:
                    <span className="font-weight-bold">$17.25</span>
                  </div>
                  <CustomButton
                    variant="text"
                    className="text-capitalize height-15"
                    onClick={() => {
                      setData({ ...data, valueOfEachHour: "17.25" });
                      handleClose();
                    }}
                  >
                    Autofill
                  </CustomButton>
                </div>
              )}
            </div>
          </Popover>
        </ThemeProvider>
      )}
    </div>
  );
};
export default StepTwo;
